import { ABTestPattern } from '../../constants';

/**
 * ShouldDisplayBottomBanner
 * @param {number} totalCount
 * @param {string} abTestGroupNo
 * @returns boolean
 */
export const shouldDisplayBottomBanner = (
  totalCount: number,
  abTestGroupNo: string
): boolean => {
  return totalCount > 0 && abTestGroupNo === ABTestPattern.A;
};
